import { render, staticRenderFns } from "./PrinterListItem.vue?vue&type=template&id=22349538"
import script from "./PrinterListItem.vue?vue&type=script&lang=js"
export * from "./PrinterListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports